import { NavLink, useLocation } from "react-router-dom";
import { BookOpen, RefreshCw, User as UserIcon, Home } from "lucide-react";
import type { LucideIcon } from "lucide-react";

interface NavItem {
  to: string;
  label: string;
  Icon: LucideIcon;
  end: boolean;
  /** Custom active predicate; falls back to NavLink's own isActive when omitted. */
  match?: (pathname: string) => boolean;
}

const NAV_ITEMS: NavItem[] = [
  { to: "/app", label: "首页", Icon: Home, end: true },
  {
    to: "/learn",
    label: "学习",
    Icon: BookOpen,
    end: false,
    // 学习 redirects through /learn → /pack/:id/start, and also covers direct
    // practice (小柴老师 lesson). NavLink's prefix match on `to="/learn"` would
    // drop the highlight on those paths, so compute active explicitly.
    match: (pathname) =>
      pathname === "/learn" ||
      pathname.startsWith("/pack/") ||
      pathname.startsWith("/app/practice"),
  },
  { to: "/app/review", label: "复习", Icon: RefreshCw, end: false },
  { to: "/app/profile", label: "我的", Icon: UserIcon, end: false },
];

export function BottomNav() {
  const { pathname } = useLocation();
  return (
    <nav className="sticky bottom-0 z-20 bg-paper border-t border-sumi/10 flex justify-around py-2 pb-[env(safe-area-inset-bottom)]">
      {NAV_ITEMS.map(({ to, label, Icon, end, match }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) => {
            const active = match ? match(pathname) : isActive;
            return `flex flex-col items-center gap-1 px-3 py-1 rounded-button transition ${
              active ? "bg-sakura-soft text-sakura" : "text-sumi-soft"
            }`;
          }}
        >
          <Icon size={22} />
          <span className="text-[11px] font-bold">{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
